import { UserHelper } from '@/helpers/user.helper';
import { AuthenticationService } from '@/services/authentication.service';
import { NgIf } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { NavigationEnd, Router, RouterLink } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-subscription-alert',
  templateUrl: './subscription-alert.component.html',
  styleUrls: ['./subscription-alert.component.scss'],
  standalone: true,
  imports: [NgIf, MatButtonModule, RouterLink]
})
export class SubscriptionAlertComponent implements OnInit, OnDestroy {
  isActiveSubscription = true;
  isPageProfile = false;
  sub = new Subscription();
  routeSub = new Subscription();
  subscribeParams = { showSubscribe: true };

  constructor(private authenticationService: AuthenticationService, private router: Router) {}

  ngOnInit(): void {
    this.sub = this.authenticationService.subscriptionState.subscribe((s) => {
      this.isActiveSubscription = UserHelper.isSubscriptionActive(s);
    });
    this.routeSub = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) this.isPageProfile = event.url.startsWith('/profile');
    });
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
    this.routeSub.unsubscribe();
  }
}
